export function isNil(subject) {
    return subject === null || subject === undefined;
}
export function isString(subject) {
    return typeof subject === 'string';
}
export function isFunction(subject) {
    return typeof subject === 'function';
}
